import type { ParentComponent } from "solid-js";
import { isNil } from "lodash-es";

type SectionProps = {
  isTemplateSection?: boolean;
  centerOnMobile?: boolean;
  fullHeight?: boolean;
};

const Section: ParentComponent<SectionProps> = (props) => (
  <div class="flex-1 overflow-y-auto">
    <div
      class="flex min-h-full grow flex-col"
      classList={{
        "justify-center text-center mobile:items-start mobile:text-start": props.centerOnMobile ?? false,
      }}
    >
      <div
        class="relative flex flex-col rounded-lg bg-surface-default p-8 mobile:m-auto mobile:border mobile:border-subtle mobile:p-6"
        classList={{
          "grow mobile:grow-0": props.fullHeight === true,
          "h-160 w-182": props.isTemplateSection,
          "mobile:w-124.5": isNil(props.isTemplateSection),
        }}
      >
        {props.children}
      </div>
    </div>
  </div>
);

export default Section;
